import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/lib/motion";

const FAQS = [
  {
    q: "Does the customer need an app?",
    a: "No. Customers simply tap the stand with a compatible smartphone and follow the notification that appears.",
  },
  {
    q: "Does it work with iPhone and Android?",
    a: "It works with modern NFC-compatible iPhone and Android devices.",
  },
  {
    q: "Do I need a Google Business Profile?",
    a: "Yes. Your business needs an active Google Business Profile that accepts customer reviews.",
  },
  {
    q: "How is it connected to my business?",
    a: "We configure the NFC stand to direct customers to your business's Google review page before shipping.",
  },
  {
    q: "Can the link be changed later?",
    a: "Yes. The NTAG215 NFC chip is reprogrammable.",
  },
  {
    q: "Is there a monthly fee?",
    a: "No. The stand is a one-time purchase with no subscription.",
  },
  {
    q: "Does the stand guarantee more Google reviews?",
    a: "No. The stand simply makes it faster and easier for genuine customers to reach your Google review page. Whether a customer chooses to leave a review is entirely up to them.",
  },
];

export const Faq = () => (
  <section id="faq" className="scroll-mt-24 bg-sand py-24 md:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">FAQ</p>
        <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          Questions, answered.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 border-t border-line">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-line">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-display text-lg font-medium tracking-tight text-ink hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-ink"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-graphite">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
